const API_PARAMS = {
    BANNER:{
        HOME_PAGE: 'home_page_banner',
    },
    CONTACT_US:{
        DETAILS: 'contact_us_nos'
       
    },
    APPLIANCES:{
        HEAVY_APPLIANCES:'heavy_appliances',
        LIGHT_APPLIANCES:'light_appliances',
        ELECTRIC_APPLIANCES:'electric_appliances'
    }
}

export default API_PARAMS;